import { toPng } from "html-to-image";

/** Renders a DOM node to PNG. 'share' opens the phone share sheet when it can take files, otherwise downloads. */
export async function shareImage(node, { fileName, title, caption, mode }) {
  const url = await toPng(node, { pixelRatio: 3, cacheBust: true });
  const file = new File([await (await fetch(url)).blob()], fileName, { type: "image/png" });
  if (mode === "share" && navigator.canShare?.({ files: [file] })) {
    await navigator.share({ files: [file], title, text: caption });
    return "shared";
  }
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  return "downloaded";
}
